import { createFilter, type FilterOptionOption } from 'react-select';

const defaultFilter = createFilter<unknown>();

export const matchesEveryWord = <TOption>(
  option: FilterOptionOption<TOption>,
  inputValue: string
): boolean =>
  inputValue.split(/\s+/).every(word => defaultFilter(option, word));
